import * as types from 'store/modules/hres80x/mutation-types'
// import { constLabels } from 'assets/js/constLabels.js'
import hres80x from 'api/hres80x'
import swal from 'sweetalert'
import hres80xLabels from 'assets/labels/hres80x'
// import { hres80xColumns } from 'assets/columns/hres80x'
// import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    sendMailDisp: true,
    notSendDisp: false,
    labels: hres80xLabels,
    // columns: hres80xColumns(),
    hisHeal: {},
    hisHealDetail: [],
    hisHealFamily: [],
    healCheckup: [],
    healCheckupDetail: [],
    healCheckupHeader: [],
    healCheckupRows: []
  },
  getters: {
    // [types.GET_HRES80X_COLUMNS] (state) {
    //   return state.columns
    // },
    [types.GET_HRES80X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES80X_HISHEAL] (state) {
      return state.hisHeal
    },
    [types.GET_HRES80X_HISHEAL_DETAIL] (state) {
      return state.hisHealDetail
    },
    [types.GET_HRES80X_HISHEAL_FAMILY] (state) {
      return state.hisHealFamily
    },
    [types.GET_HRES80X_HEAL_CHECKUP_HEADER] (state) {
      return state.healCheckupHeader
    },
    [types.GET_HRES80X_HEAL_CHECKUP_DETAIL] (state) {
      return state.healCheckupDetail
    },
    [types.GET_HRES80X_HEAL_CHECKUP_ROWS] (state) {
      return state.healCheckupRows
    }
  },
  mutations: {
    // [types.SET_HRES80X_COLUMNS] (state, labels) {
    //   for (var keyLang of configLabel.allLang) {
    //     state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
    //     state.columns[keyLang].notSend = configLabel.replaceLabelToColumns(state.columns[keyLang].notSend, labels[keyLang])
    //   }
    // },
    [types.SET_HRES80X_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES80X_HISHEAL] (state, data) {
      state.hisHeal = data.thisheal.data
      state.hisHealDetail = data.thisheald.data.rows
      state.hisHealFamily = data.thishealf.data.rows
      state.healCheckup = data.thealinf.data.rows
      state.healCheckupDetail = state.healCheckup
      // assign detail value
      // let dataMapping = state.healCheckup.map((dataMap, index) => {
      //   let retData = {
      //     dataMap.dteyear + '':
      //   }
      //   dataMapping[index][dataMap.dteyear + ''][dataMap.codchkhl]['descheck'] = dataMap.descheck
      //   dataMapping[index][dataMap.dteyear + ''][dataMap.codchkhl]['chkresul'] = dataMap.chkresul
      // })
      // end assign detail value----------------------------------------------
      // distinct dateYears
      let dateYears = state.healCheckup.map(dataMap => {
        return {dteyear: dataMap.dteyear, typheal: dataMap.typheal, desc_codheal: dataMap.desc_codheal, dteheal: dataMap.dteheal}
      })
      let newarr = []
      let unique = ''
      dateYears.map(item => {
        if (unique !== item.dteyear + item.typheal) {
          unique = item.dteyear + item.typheal
          newarr.push(item)
        }
      })
      state.healCheckupHeader = newarr
      // end distinct dateYears-----------------------------------------------
      // distinct Code Check Heal
      let rowsList = state.healCheckup.map(dataMap => {
        return {codchkhl: dataMap.codchkhl, desc_codchkhl: dataMap.desc_codchkhl}
      })
      var newarr2 = []
      var unique2 = {}
      rowsList.map(dataMap => {
        if (!unique2[dataMap.codchkhl]) {
          newarr2.push(dataMap)
          unique2[dataMap.codchkhl] = dataMap
        }
      })
      state.healCheckupRows = newarr2
      // end distinct Code Check Heal-----------------------------------------
    }
  },
  actions: {
    [types.RECEIVED_HRES80X_COLUMNS_LABELS] ({ commit }) {
      hres80x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          // commit(types.SET_HRES80X_COLUMNS, data.labels)
          commit(types.SET_HRES80X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES80X_HISHEAL] ({ commit }, codempid) {
      hres80x.getHisHeal(codempid)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES80X_HISHEAL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres80x/index.js